import { Dialog } from '@cobliteam/colib-ui/Dialog';
import useAlertHooksStore from '@cobliteam/hooks/src/useAlertHooks/useAlertHooksStore';
import DialogAlertHookConfirm from './DialogAlertHookConfirm';
import DialogAlertHookSuggestion from './DialogAlertHookSuggestion';

/**
 * Globally mounted alert-hook suggestion modal. Visibility is store-driven: `useTriggerAlertHook`
 * decides when to `open()`, the modal reads `current` and renders the right step. There is no
 * `open` prop because journey code never reaches the modal directly — it goes through the store.
 *
 * AE-2326 / PRD: Sugestão de alertas (hooks). See `modules/hooks/src/useAlertHooks/`.
 */
const DialogAlertHook = () => {
  const current = useAlertHooksStore((state) => state.current);
  const close = useAlertHooksStore((state) => state.close);
  if (!current) return null;
  return (
    <Dialog open onOpenChange={(open) => !open && close()} modal>
      {current.step === 'suggestion' ? <DialogAlertHookSuggestion current={current} /> : <DialogAlertHookConfirm current={current} />}
    </Dialog>
  );
};
export default DialogAlertHook;
